<div class="hls-notification hls-notification--{{ type | lowercase }}">
  @if (!noIcon) {
    <hls-icon class="hls-notification__icon hls-notification__type-icon"
      [icon]="icon || typeIcon"
    [ngClass]="{'hls-notification__icon--adjusted-to-text': !isSlotEmpty(contentSlotRef) }"></hls-icon>
  }
  <div class="hls-notification__content">
    <h3 [innerText]="headline"></h3>
    <div class="hls-notification__text"
      [ngClass]="{'hls-notification__text--hidden': isSlotEmpty(contentSlotRef) }">
      <span>
        <slot #contentSlot></slot>
      </span>
    </div>
  </div>
  @if (dismissable) {
    <hls-icon class="hls-notification__icon hls-notification__close-icon"
      icon="action-dismiss"
      (click)="dismissInternal(NotificationDismissSource.CloseAction)"
    [ngClass]="{'hls-notification__icon--adjusted-to-text': !isSlotEmpty(contentSlotRef) }"></hls-icon>
  }
</div>
